import { AutogenModelTransmissionControlList, AutogenRowTransmissionControlList } from "./autogen/AutogenModelTransmissionControlList";

export class ModelTransmissionControlList extends AutogenModelTransmissionControlList<RowTransmissionControlList> {
	constructor() {
		super(RowTransmissionControlList);
	}
}

export class RowTransmissionControlList extends AutogenRowTransmissionControlList {
}